import { Actor, Circle, CollisionType, Color, Engine, Scene, ScreenElement, Sprite, vec } from "excalibur";
import { Resources } from "../../resources";
import { collision_groups } from "../../scenes/level-one/collision_groups";
import { LevelOne } from "../../scenes/level-one/level-one";
import { Tower } from "../towers/tower";
import { DescriptionBox } from "./description_box";
import { DiceButtons } from "./dice_buttons";
import { DiceDisplay } from "./dice_display";
import { TowerButton } from "./tower_button";
import { TowerButtons } from "./tower_buttons";
import { TowerCursor } from "./tower_cursor";
import { TowerSpec } from "./tower_specs";

export class BottomBar extends ScreenElement {
    public towerButtons: TowerButtons;
    public descriptionBox: DescriptionBox;
    public diceButtons: DiceButtons;
    public diceDisplay: DiceDisplay;

    constructor(private level: LevelOne, hudHeight: number) {
        super({
            pos: vec(0, level.engine.drawHeight - hudHeight),
            width: level.engine.drawWidth,
            height: hudHeight,
            collisionGroup: collision_groups.uiGroup
        });
    }
    
    onInitialize() {
        this.collider.useBoxCollider(this.width, this.height, vec(0, 0))
        this.body.collisionType = CollisionType.Passive;

        this.towerButtons = new TowerButtons(this.level, this.height);
        this.addChild(this.towerButtons);

        this.descriptionBox = new DescriptionBox(500, 800, this.height);
        this.addChild(this.descriptionBox);

        this.diceButtons = new DiceButtons(this.level, this.width - this.height, this.height, this.height);
        this.addChild(this.diceButtons);

        this.diceDisplay = new DiceDisplay(this.level, 1220, 0, this.height, this.height);
        this.addChild(this.diceDisplay);

        const sprite = new Sprite({
            image: Resources.bottomBar,
            destSize: {
                width: this.width,
                height: this.height
            },
        })

        this.graphics.use(sprite);
    }
}